module.exports = __webpack_public_path__ + "static/media/YB5M11_3.97010f63.jpg";